import React from "react";
import Navbar from "../components/Navbar";
import AboutUs from "../components/AboutUs";
import Aside from "../components/Aside";
import Footer from "../components/Footer";

const AboutUsPage = () => {
  return (
    <>
      <Navbar />
      <AboutUs />
      <Aside />
      <Footer />
    </>
  );
};

export default AboutUsPage;
